import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_carrier-connect-21/artifacts/svda2ys5_Concept%207%4072x%20%281%29.png";

export const Footer = () => {
    return (
        <footer
            data-testid="footer"
            className="relative mt-32 border-t border-gray-200"
        >
            <div className="grid-bg absolute inset-0 opacity-30 pointer-events-none" />
            <div className="relative mx-auto max-w-7xl px-5 md:px-8 py-16">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <img
                            src={LOGO_URL}
                            alt="Nexship"
                            className="h-12 w-auto mb-6"
                        />
                        <p className="text-gray-600 text-sm max-w-sm leading-relaxed">
                            Nexship is your single point of contact for managed
                            transport brokerage. We move it for you — every
                            load, every route.
                        </p>
                        <div className="mt-6 flex flex-col gap-2 text-sm text-gray-700">
                            <a
                                href="mailto:info@nexship.co.za"
                                className="inline-flex items-center gap-2 hover:text-brand-green"
                                data-testid="footer-email"
                            >
                                <Mail size={14} /> info@nexship.co.za
                            </a>
                            <span className="inline-flex items-center gap-2">
                                <Phone size={14} /> (016) 001 0388
                            </span>
                            <span className="inline-flex items-center gap-2">
                                <MapPin size={14} /> Gauteng, South Africa
                            </span>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <p className="mono text-xs text-gray-500 uppercase mb-4">
                            Company
                        </p>
                        <ul className="flex flex-col gap-3 text-sm">
                            <li>
                                <Link
                                    to="/about"
                                    className="text-gray-800 hover:text-brand-green"
                                >
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/services"
                                    className="text-gray-800 hover:text-brand-green"
                                >
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    className="text-gray-800 hover:text-brand-green"
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="mono text-xs text-gray-500 uppercase mb-4">
                            Get Started
                        </p>
                        <div className="flex flex-col gap-3">
                            <Link
                                to="/request-transport"
                                className="btn-primary text-sm w-fit"
                                data-testid="footer-cta-request"
                            >
                                Request Transport <ArrowUpRight size={14} />
                            </Link>
                            <Link
                                to="/carrier-signup"
                                className="btn-ghost text-sm w-fit"
                                data-testid="footer-cta-carrier"
                            >
                                Become a Carrier <ArrowUpRight size={14} />
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="divider-line my-10" />

                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-gray-500">
                    <p className="mono">
                        © {new Date().getFullYear()} NEXSHIP — ALL RIGHTS
                        RESERVED
                    </p>
                    <p className="mono">
                        WE&nbsp;MOVE&nbsp;IT&nbsp;FOR&nbsp;YOU
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
